import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PriceListLine } from 'src/app/_models/pricelistline';
import { PricelistService } from 'src/app/_services/pricelist.service';
import { BasketService } from 'src/app/_services/basket.service';
import { BasketAdd } from 'src/app/_models/basketadd';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from '../_services/customer.service';
import { Brand } from '../_models/brand';
import { Model } from '../_models/model';
import { Type } from '../_models/type';
import { ArtikelGroep } from '../_models/artikelGroep';
import { Dialog, DialogRef} from '@angular/cdk/dialog'; 
import { MenuService } from '../_services/menu.service';
import { HoofdMenuDto } from '../_models/hoofdMenuDto';
import { Observable } from 'rxjs';
import { SubMenuDto } from '../_models/subMenuDto';
import { MenuDto } from '../_models/menuDto';
import { DocumentDto } from '../_models/documentdto';
import { VolledigMenuDto } from '../_models/volledigMenuDto';
import { LicensePlate } from '../_models/licensePlate';
import { VinHistoryService } from '../_services/vin-history.service';
import { PromotionService } from '../_services/promotion.service';
import { CustomerPromotion } from '../_models/customerpromotion';

@Component({
    selector: 'app-pricelist',
    templateUrl: './pricelist.component.html',
    styleUrls: ['./pricelist.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PricelistComponent implements OnInit, AfterViewInit {
  searchForm!: FormGroup;
  licensePlateForm!: FormGroup;
  orderForm!: FormGroup;
  modelBrandForm!: FormGroup;
  searchpricelistlines!: PriceListLine[];
  brands!: string[];
  
  errorMessage!: string;
  toonLicenseplateInfo!: boolean;
  licensePlateVolledigmenu!: VolledigMenuDto[];
  licensePlateInfo!: LicensePlate;
  licensePlateHoofdmenu!: HoofdMenuDto[];
  licensePlateHoofdmenuSelected: HoofdMenuDto | null = null;
  licensePlateSubmenu!: SubMenuDto[];
  licensePlateSubmenuSelected: SubMenuDto | null = null;
  licensePlateMenu!: MenuDto[];
  licensePlateMenuSelected: MenuDto | null = null;
  activeVehicleSearchType: 'licenseplate' | 'vin' = 'licenseplate';
  activeVehicleIdentifier = '';
  vinHistory: string[] = [];

  modelbrands!: Brand[];
  selectedModelBrand: Brand | null = null;
  modelmodels!: Model[];
  selectedModelModel: Model | null = null;
  modeltypes!: Type[];
  selectedModelType: Type | null = null;
  toonLicenseplateInfoModel!: boolean;
  licensePlateInfoModel!: string;
  artikelGroepen!: ArtikelGroep[];
  SelectedModelArtikelGroep!: ArtikelGroep;
  modelVolledigmenu!: VolledigMenuDto[];
  modelHoofdmenu!: HoofdMenuDto[];
  modelHoofdmenuSelected!: HoofdMenuDto;
  modelSubmenu!: SubMenuDto[];
  modelSubmenuSelected!: SubMenuDto;
  modelMenu!: MenuDto[];
  modelMenuSelected!: MenuDto;

  pictureDialogRef!: DialogRef<unknown, any>;
  promotionDialogRef!: DialogRef<unknown, any>;
  customerPromotion!: CustomerPromotion;
  promotionQuantity: number = 1;

  @ViewChild('promotionTemplate') promotionTemplate!: TemplateRef<unknown>;
  pictureUrl1!: string;
  pictureUrl2!: string;
  pictureUrl3!: string;
  pictureStatus1!: string;
  pictureStatus2!: string;
  pictureStatus3!: string;
  pictureUrlActive!: string;
  picturePartNumber!: string;
  documents!: DocumentDto[];
  documentsAvailable!: boolean;
  dialogRefHeight!: number;

  constructor(private pricelistService: PricelistService, private fb: FormBuilder, 
    private basketService: BasketService, private toastr: ToastrService, public customerService: CustomerService, private dialog: Dialog, private menuService: MenuService,
    private vinHistoryService: VinHistoryService, private promotionService: PromotionService) { }

  ngOnInit(): void {
    this.initializeForm();
    this.toonLicenseplateInfo = false;
    this.toonLicenseplateInfoModel = false;

    this.promotionService.getCustomerPromotion().subscribe({
      next: promotion => {
        if (promotion) {
          this.customerPromotion = promotion;
          this.promotionDialogRef = this.dialog.open(this.promotionTemplate, {
            width: '700px',
            height: '700px',
            panelClass: 'mydialog'
          });
        }
      }
    });

    //this.licensePlateArtikelGroepen = new Array ("Voetmattenset", "Toevoer, Ureumstofinjectie");

    this.customerService.currentUser$.subscribe(user => { 
      this.brands = user?.brands;    
    });

    this.vinHistoryService.getVinHistory().subscribe({
      next: vins => this.vinHistory = vins ?? [],
      error: () => this.vinHistory = []
    });

    this.pricelistService.getModelBrands().subscribe({
      next: licensePlateInfo  => {
        if (typeof(licensePlateInfo) === 'string')
        {
          this.errorMessage = licensePlateInfo;
          return;
        }
        this.errorMessage = "";
        this.modelbrands = licensePlateInfo?.brands;  

      },
      error: err => this.errorMessage = err
    });
  }

  ngAfterViewInit(): void { }

  orderPromotion() {
    if (!this.customerPromotion || this.promotionQuantity < 1) return;
    const basketadd: BasketAdd = {
      xref: this.customerPromotion.xref,
      aantal: this.promotionQuantity,
      prijs: this.customerPromotion.priceTiers?.length > 0 ? this.customerPromotion.priceTiers[0].price : 0,
      merk: this.customerPromotion.merk,
      promotionId: this.customerPromotion.promotionId
    };
    this.basketService.Add(basketadd);
    this.toastr.success('Promotion added to order.');
    this.promotionDialogRef?.close();
  }

  initializeForm(){
    
    this.searchForm = this.fb.group({
      productcode: ['', Validators.required],
      brand: ['Any']

    })

    this.licensePlateForm = this.fb.group({
      licenseplate: ['', Validators.required],
      vin: [''],
      hoofdgroep: [, ],
      licensePlateHoofdmenuSelected: [,],
      licensePlateSubmenuSelected: [,],
      licensePlateMenuSelected: [,]
    })

    this.modelBrandForm = this.fb.group({
      modelbrand: ['', Validators.required],
      selectedModelBrand: [,],
      selectedModelModel: [,],
      selectedModelType: [,],
      modelHoofdmenuSelected: [,],
      modelSubmenuSelected: [,],
      modelMenuSelected: [,]
    })

    this.orderForm = this.fb.group({
      'searchlijn': this.fb.array([])
    })
  }
  
  search(){
    (<FormArray>this.orderForm.get('searchlijn')).clear();

    if (this.searchForm.value.brand.toLowerCase() == "any")
    {
      this.pricelistService.getPrices(this.searchForm.value.productcode).subscribe({
        next: lines => {
          this.errorMessage = "";
          this.toonLicenseplateInfo = false;
          this.searchpricelistlines = lines;
          
          lines.forEach(element => {
            //console.log(element)
            const group = this.fb.group({
              xref: new FormControl(element.xref), 
              price: new FormControl(element.prijs),
              brand: new FormControl(element.merk),
              qty: new FormControl('')
            });
            (<FormArray>this.orderForm.get('searchlijn')).push(group);
          })
        },
        error: err => this.errorMessage = err
      });
    }
    else
    {
      this.pricelistService.getPricesBrand(this.searchForm.value.brand, this.searchForm.value.productcode).subscribe({
        next: lines => {
          this.searchpricelistlines = lines;
          lines.forEach(element => {
            const group = this.fb.group({
              xref: new FormControl(element.xref), 
              price: new FormControl(element.prijs),
              brand: new FormControl(element.merk),
              qty: new FormControl('')
            });
            (<FormArray>this.orderForm.get('searchlijn')).push(group);
          })
        },
        error: err => this.errorMessage = err
      });
    }
  }

  //#region license plate

  searchLicensePlate(){
    const licensePlate = this.licensePlateForm.value.licenseplate?.trim();

    if (!licensePlate)
    {
      return;
    }

    this.licensePlateForm.patchValue({
      licenseplate: licensePlate.toUpperCase(),
      vin: ''
    });

    this.activeVehicleSearchType = 'licenseplate';
    this.activeVehicleIdentifier = licensePlate.toUpperCase();

    this.resetVehicleSearch();
    this.loadVehicleMenu(this.activeVehicleIdentifier);
    this.loadVehicleResult(this.pricelistService.getLicensePlate(this.activeVehicleIdentifier, '1'), true);

  }

  addVinTag = (term: string) => term.toUpperCase();

  onVinSearch(event: {term: string, items: string[]}): void {
    this.licensePlateForm.controls['vin'].setValue(event.term.toUpperCase(), { emitEvent: false });
  }

  searchVin(){
    console.log("searchvin");
    const vin = this.licensePlateForm.value.vin?.trim().toUpperCase();

    if (!vin)
    {
      return;
    }

    if (vin.length !== 17)
    {
      this.errorMessage = 'VIN must contain exactly 17 characters.';
      this.toonLicenseplateInfo = false;
      return;
    }

    this.licensePlateForm.patchValue({
      vin: vin,
      licenseplate: ''
    });

    this.activeVehicleSearchType = 'vin';
    this.activeVehicleIdentifier = vin;

    this.resetVehicleSearch();
    this.loadVehicleMenu(this.activeVehicleIdentifier);
    this.loadVehicleResult(this.pricelistService.getVin(this.activeVehicleIdentifier, '1'), true);
  }

  private resetVehicleSearch()
  {
    (<FormArray>this.orderForm.get('searchlijn')).clear();
    this.licensePlateForm.patchValue({
      licensePlateHoofdmenuSelected: null,
      licensePlateSubmenuSelected: null,
      licensePlateMenuSelected: null
    });
    this.licensePlateHoofdmenuSelected = null;
    this.licensePlateSubmenuSelected = null;
    this.licensePlateMenuSelected = null;
    this.licensePlateHoofdmenu = [];
    this.licensePlateSubmenu = [];
    this.licensePlateMenu = [];
    this.searchpricelistlines = [];
  }

  private loadVehicleMenu(identifier: string)
  {
    const menuRequest$ = this.activeVehicleSearchType === 'vin'
      ? this.menuService.getVolledigMenuVin(identifier)
      : this.menuService.getVolledigMenuLicensePlate(identifier);

    menuRequest$.subscribe({
      next: menustructuur => {
        this.licensePlateVolledigmenu = menustructuur;

        const uniqueDict : Record<number, HoofdMenuDto> = {}

        for (const obj of menustructuur)
        {
          if (!uniqueDict[obj.hoofdGroepId])
          {
            var newObject: HoofdMenuDto = {hoofdGroepId: obj.hoofdGroepId, hoofdGroep: obj.hoofdGroep};

            uniqueDict[obj.hoofdGroepId] = newObject;
          }
        }

        this.licensePlateHoofdmenu = Object.values(uniqueDict);

      },
      error: err => this.errorMessage = err
    })
  }

  private addVinToHistory(vin: string) {
    this.vinHistory = [vin, ...this.vinHistory.filter(v => v !== vin)];
  }

  private loadVehicleResult(request$: Observable<LicensePlate>, updateVehicleInfo: boolean)
  {
    request$.subscribe({
      next: licensePlateInfo  => {
        if (typeof(licensePlateInfo) === 'string')
        {
          this.errorMessage = licensePlateInfo;
          this.toonLicenseplateInfo = false;
          return;
        }
        this.errorMessage = "";
        this.toonLicenseplateInfo = true;
        if (this.activeVehicleSearchType === 'vin') {
          this.addVinToHistory(this.activeVehicleIdentifier);
        }
        if (updateVehicleInfo)
        {
          this.licensePlateInfo = licensePlateInfo;
        }
        this.searchpricelistlines = licensePlateInfo.prijslijstLijnen;
        this.populateOrderLines(licensePlateInfo.prijslijstLijnen);
      },
      error: err => this.errorMessage = err
    });
  }

  private populateOrderLines(lines: PriceListLine[])
  {
    lines.forEach(element => {
      const group = this.fb.group({
        xref: new FormControl(element.xref), 
        price: new FormControl(element.prijs),
        brand: new FormControl(element.merk),
        qty: new FormControl('')
      });

      (<FormArray>this.orderForm.get('searchlijn')).push(group);
    })
  }

  changeHoofdgroep(selectedHoofdmenu: HoofdMenuDto)
  {
    //console.log(selectedHoofdmenu);
    this.licensePlateHoofdmenuSelected = selectedHoofdmenu;
    this.licensePlateForm.patchValue({
      licensePlateSubmenuSelected: null
    });
    this.licensePlateForm.patchValue({
      licensePlateMenuSelected: null
    });
    this.searchpricelistlines = [];

    //this.licensePlateSubmenu$ = this.menuService.getSubMenu(selectedHoofdmenu.hoofdGroepId);

    const uniqueDict : Record<number, SubMenuDto> = {};

    for (const obj of this.licensePlateVolledigmenu)
    {
      if (obj.hoofdGroepId === selectedHoofdmenu.hoofdGroepId)
      {
        if (!uniqueDict[obj.subGroepId])
        {
          var newObject: SubMenuDto = {subGroepId: obj.subGroepId, subGroep: obj.subGroep};

          uniqueDict[obj.subGroepId] = newObject;
        }
      }
    }

    this.licensePlateSubmenu = Object.values(uniqueDict);
    
  }

  changeSubgroep(selectedSubmenu: SubMenuDto)
  {
    //console.log(selectedSubmenu);
    this.licensePlateSubmenuSelected = selectedSubmenu;
    this.searchpricelistlines = [];
    this.licensePlateForm.patchValue({
      licensePlateMenuSelected: null
    });
    //this.licensePlateMenu$ = this.menuService.getMenu(this.licensePlateHoofdmenuSelected.hoofdGroepId, selectedSubmenu.subGroepId);

    const uniqueDict : Record<number, MenuDto> = {};

    for (const obj of this.licensePlateVolledigmenu)
    {
      if (obj.hoofdGroepId === this.licensePlateHoofdmenuSelected!.hoofdGroepId && obj.subGroepId === this.licensePlateSubmenuSelected.subGroepId)
      {
        //console.log(obj.genArtNr);
        if (!uniqueDict[obj.genArtNr])
        {
          var newObject: MenuDto = {genArtNr: obj.genArtNr, genOmschrijving: obj.genOmschrijving};

          uniqueDict[obj.genArtNr] = newObject;
        }
      }
    }

    this.licensePlateMenu = Object.values(uniqueDict);
  }

  changeGroep(selectedMenu: MenuDto)
  {
    //console.log(selectedMenu);
    //this.licensePlateSubmenuSelected = selectedSubmenu;
    //this.licensePlateMenu$ = this.menuService.getMenu(this.licensePlateHoofdmenuSelected.hoofdGroepId, selectedSubmenu.subGroepId);

    (<FormArray>this.orderForm.get('searchlijn')).clear();

    //this.licensePlateVolledigmenu$ = this.menuService.getVolledigMenu(this.licensePlateForm.value.licenseplate);

    const currentIdentifier = this.activeVehicleIdentifier || this.licensePlateForm.value.licenseplate?.trim();

    if (!currentIdentifier)
    {
      return;
    }

    if (this.activeVehicleSearchType === 'vin')
    {
      this.loadVehicleResult(this.pricelistService.getVinGenart(currentIdentifier, selectedMenu.genArtNr), false);
      return;
    }

    this.loadVehicleResult(this.pricelistService.getLicensePlateGenart(currentIdentifier, selectedMenu.genArtNr), false);


  }

  //#endregion

  //#region model

  changeModelBrand(selectedBrand: Brand)
  {
    //console.log(selectedBrand);
    this.selectedModelBrand = selectedBrand;
    this.selectedModelModel = null;
    this.selectedModelType = null;
    this.searchpricelistlines = [];
    this.modelBrandForm.patchValue({
      selectedModelModel: null,
      selectedModelType: null,
      modelHoofdmenuSelected: null,
      modelSubmenuSelected: null,
      modelMenuSelected: null
    });

    this.pricelistService.getModelModels(selectedBrand.id).subscribe({
      next: modelsearch  => {
        if (typeof(modelsearch) === 'string')
        {
          this.errorMessage = modelsearch;
          return;
        }
        this.errorMessage = "";
        this.modelmodels = modelsearch?.models;
        this.selectedModelModel = null;
        this.selectedModelType = null; 
        this.toonLicenseplateInfoModel = false;
      },
      error: err => this.errorMessage = err
    });

  }

  changeModelModel(selectedModel: Model)
  {
    //console.log(selectedModel);
    this.selectedModelModel = selectedModel;
    this.selectedModelType = null;
    this.searchpricelistlines = [];
    this.modelBrandForm.patchValue({
      selectedModelType: null,
      modelHoofdmenuSelected: null,
      modelSubmenuSelected: null,
      modelMenuSelected: null
    });
    this.pricelistService.getModelTypes(this.selectedModelBrand!.id, selectedModel.id).subscribe({
      next: modelsearch  => {
        if (typeof(modelsearch) === 'string')
        {
          this.errorMessage = modelsearch;
          return;
        }
        this.errorMessage = "";
        this.modeltypes = modelsearch?.types;  
        this.selectedModelType = null; 
        this.toonLicenseplateInfoModel = false;
      },
      error: err => this.errorMessage = err
    });

  }

  changeModelType(selectedType: Type)
  {
    this.selectedModelType = selectedType;
    this.searchpricelistlines = [];
    console.log("changemodeltype");
    console.log(selectedType);
    console.log(this.selectedModelBrand!.id + " " + this.selectedModelModel!.id + " " + this.selectedModelType.id);

    this.modelBrandForm.patchValue({
      modelHoofdmenuSelected: null,
      modelSubmenuSelected: null,
      modelMenuSelected: null
    });

    this.menuService.getVolledigMenuKtype(this.selectedModelType.id).subscribe({
      next: menustructuur => {
        //console.log(menustructuur);
        this.modelVolledigmenu = menustructuur;

        const uniqueDict : Record<number, HoofdMenuDto> = {}

        for (const obj of menustructuur)
        {
          if (!uniqueDict[obj.hoofdGroepId])
          {
            var newObject: HoofdMenuDto = {hoofdGroepId: obj.hoofdGroepId, hoofdGroep: obj.hoofdGroep};

            uniqueDict[obj.hoofdGroepId] = newObject;
          }
        }

        this.modelHoofdmenu = Object.values(uniqueDict);

      }
    })


    this.pricelistService.getModelArticleGroups(this.selectedModelBrand!.id, this.selectedModelModel!.id, selectedType.id).subscribe({
      next: licensePlateInfo  => {
        if (typeof(licensePlateInfo) === 'string')
        {
          this.errorMessage = licensePlateInfo;
          return;
        }
        //console.log(licensePlateInfo);

        this.errorMessage = "";
        this.toonLicenseplateInfoModel = true;
        this.artikelGroepen = licensePlateInfo?.artikelGroepen.filter(e => e.name.includes("Ureumstofinjectie") || e.id === 215);
        this.licensePlateInfoModel = "Motor Code: " + this.selectedModelType!.motorCode 
                      + "<br/>From: " + this.selectedModelType!.from 
                      + "<br/>Until: " + this.selectedModelType!.until 
                      + "<br/>Power: " + this.selectedModelType!.power ;
        this.searchpricelistlines = licensePlateInfo.prijslijstLijnen;
        
        licensePlateInfo.prijslijstLijnen.forEach(element => {
          const group = this.fb.group({
            xref: new FormControl(element.xref), 
            price: new FormControl(element.prijs),
            brand: new FormControl(element.merk),
            qty: new FormControl('')
          });

          (<FormArray>this.orderForm.get('searchlijn')).push(group);
        })

      },
      error: err => this.errorMessage = err
    });

  }



  changeHoofdgroepModel(selectedHoofdmenu: HoofdMenuDto)
  {
    console.log(selectedHoofdmenu);
    this.modelHoofdmenuSelected = selectedHoofdmenu;
    this.modelBrandForm.patchValue({
      modelSubmenuSelected: null
    });
    this.modelBrandForm.patchValue({
      modelMenuSelected: null
    });
    this.searchpricelistlines = [];

    //this.licensePlateSubmenu$ = this.menuService.getSubMenu(selectedHoofdmenu.hoofdGroepId);

    const uniqueDict : Record<number, SubMenuDto> = {};

    for (const obj of this.modelVolledigmenu)
    {
      if (obj.hoofdGroepId === selectedHoofdmenu.hoofdGroepId)
      {
        if (!uniqueDict[obj.subGroepId])
        {
          var newObject: SubMenuDto = {subGroepId: obj.subGroepId, subGroep: obj.subGroep};

          uniqueDict[obj.subGroepId] = newObject;
        }
      }
    }

    this.modelSubmenu = Object.values(uniqueDict);
    
  }

  changeSubgroepModel(selectedSubmenu: SubMenuDto)
  {
    //console.log(selectedSubmenu);
    this.modelSubmenuSelected = selectedSubmenu;
    this.searchpricelistlines = [];
    this.modelBrandForm.patchValue({
      modelMenuSelected: null
    });
    //this.licensePlateMenu$ = this.menuService.getMenu(this.licensePlateHoofdmenuSelected.hoofdGroepId, selectedSubmenu.subGroepId);

    const uniqueDict : Record<number, MenuDto> = {};

    for (const obj of this.modelVolledigmenu)
    {
      if (obj.hoofdGroepId === this.modelHoofdmenuSelected.hoofdGroepId && obj.subGroepId === this.modelSubmenuSelected.subGroepId)
      {
        //console.log(obj.genArtNr);
        if (!uniqueDict[obj.genArtNr])
        {
          var newObject: MenuDto = {genArtNr: obj.genArtNr, genOmschrijving: obj.genOmschrijving};

          uniqueDict[obj.genArtNr] = newObject;
        }
      }
    }

    this.modelMenu = Object.values(uniqueDict);
  }


  changeGroepModel(selectedMenu: MenuDto)
  {
    //console.log(selectedMenu);
    //this.licensePlateSubmenuSelected = selectedSubmenu;
    //this.licensePlateMenu$ = this.menuService.getMenu(this.licensePlateHoofdmenuSelected.hoofdGroepId, selectedSubmenu.subGroepId);

    (<FormArray>this.orderForm.get('searchlijn')).clear();

    //this.licensePlateVolledigmenu$ = this.menuService.getVolledigMenu(this.licensePlateForm.value.licenseplate);

    this.pricelistService.getKtypeGenart(this.selectedModelType!.id, selectedMenu.genArtNr).subscribe({
      next: licensePlateInfo  => {
        if (typeof(licensePlateInfo) === 'string')
        {
          this.errorMessage = licensePlateInfo;
          this.toonLicenseplateInfoModel = false;
          return;
        }
        this.errorMessage = "";
        this.toonLicenseplateInfoModel = true;
        //this.licensePlateInfo = licensePlateInfo.autoMerk + " " + licensePlateInfo.autoModel + " " + licensePlateInfo.autoType;
        this.searchpricelistlines = licensePlateInfo.prijslijstLijnen;
        licensePlateInfo.prijslijstLijnen.forEach(element => {
          const group = this.fb.group({
            xref: new FormControl(element.xref), 
            price: new FormControl(element.prijs),
            brand: new FormControl(element.merk),
            qty: new FormControl('')
          });

          (<FormArray>this.orderForm.get('searchlijn')).push(group);
        })
      },
      error: err => this.errorMessage = err
    });


  }

  //#endregion
  get searchlijn() : FormArray{
    return this.orderForm.get("searchlijn") as FormArray;
  }

  onAddToBasket()
  {   
    (<FormArray>this.orderForm.get('searchlijn')).controls.forEach(element =>{
      if ((element.value.qty*1) > 0)
      {
        let basketadd : BasketAdd = {
          xref : element.value.xref,
          aantal : element.value.qty*1,
          prijs : element.value.price,
          merk : element.value.brand,
          promotionId: 0
        }

        this.basketService.Add(basketadd);
        this.toastr.success("Product successfully added to order.");
        this.searchpricelistlines = [];
        this.orderForm.reset();

      }
    })
  }



  

  

  


  

  changeModelArtikelGroep(selectedArtikelgroep: ArtikelGroep)
  {
    //console.log(selectedArtikelgroep);
    //console.log(this.selectedModelBrand.id + " " + this.selectedModelModel.id + " " + this.selectedModelType.id);
    this.pricelistService.getModelArticleGroup(this.selectedModelBrand!.id, this.selectedModelModel!.id, this.selectedModelType!.id, selectedArtikelgroep.id).subscribe({
      next: licensePlateInfo  => {
        if (typeof(licensePlateInfo) === 'string')
        {
          this.errorMessage = licensePlateInfo;
          return;
        }
        //console.log(licensePlateInfo);
        this.errorMessage = "";

        this.searchpricelistlines = licensePlateInfo.prijslijstLijnen;
        
        licensePlateInfo.prijslijstLijnen.forEach(element => {
          const group = this.fb.group({
            xref: new FormControl(element.xref), 
            price: new FormControl(element.prijs),
            brand: new FormControl(element.merk),
            qty: new FormControl('')
          });

          (<FormArray>this.orderForm.get('searchlijn')).push(group);
        })

      },
      error: err => this.errorMessage = err
    });

  }


  changeTab(event: any)
  {
    this.toonLicenseplateInfoModel = false;
    this.toonLicenseplateInfo = false;

    this.licensePlateForm.patchValue({
      licenseplate:null,
      vin: null,
      licensePlateHoofdmenuSelected: null
    });
    this.licensePlateForm.patchValue({
      licensePlateSubmenuSelected: null
    });
    this.licensePlateForm.patchValue({
      licensePlateMenuSelected: null
    });

    this.selectedModelBrand = null;
    this.selectedModelModel = null;
    this.selectedModelType = null;
    
    this.modelBrandForm.patchValue({
      selectedModelBrand : null,
      selectedModelModel: null,
      selectedModelType: null,
      modelHoofdmenuSelected: null,
      modelSubmenuSelected: null,
      modelMenuSelected: null
    });

    this.licensePlateHoofdmenuSelected = null;
    this.licensePlateSubmenuSelected = null;
    this.licensePlateMenuSelected = null;
    this.activeVehicleIdentifier = '';
    this.activeVehicleSearchType = 'licenseplate';
    

    this.searchpricelistlines = [];
  }

  openPicture(template: TemplateRef<unknown>, pictureArticle1: string,pictureArticle2: string, pictureArticle3: string, picturePartnumber: string, documents: DocumentDto[]) 
  {
    this.pictureUrl1 = pictureArticle1;
    this.pictureUrl2 = pictureArticle2;
    this.pictureUrl3 = pictureArticle3;
    this.pictureUrlActive = pictureArticle1;
    this.pictureStatus1 = "pictureactive";
    this.pictureStatus2 = "pictureinactive";
    this.pictureStatus3 = "pictureinactive";
    this.picturePartNumber = picturePartnumber;
    this.documents = documents;
    if (documents === undefined || documents.length < 1)
    {
      this.documentsAvailable = false;
      this.dialogRefHeight = 600;
    }
    else if (documents.length === 1 && documents[0] === null)
    {
      this.documentsAvailable = false;
      this.dialogRefHeight = 600;
    }
    else
    {
      this.documentsAvailable = true;
      this.dialogRefHeight = 400;
    }
    // you can pass additional params, choose the size and much more
    this.pictureDialogRef = this.dialog.open(template,{
      height: '800px',
      width: '1000px',

      panelClass: 'mydialog',
    });
 }

 changeActivePicture(pictureNumber: number)
 {
    if (pictureNumber == 1)
    {
      this.pictureUrlActive = this.pictureUrl1;
      this.pictureStatus1 = "pictureactive";
      this.pictureStatus2 = "pictureinactive";
      this.pictureStatus3 = "pictureinactive";
    }
    if (pictureNumber == 2)
    {
      this.pictureUrlActive = this.pictureUrl2;
      this.pictureStatus1 = "pictureinactive";
      this.pictureStatus2 = "pictureactive";
      this.pictureStatus3 = "pictureinactive";
    }
    if (pictureNumber == 3)
    {
      this.pictureUrlActive = this.pictureUrl3;
      this.pictureStatus1 = "pictureinactive";
      this.pictureStatus2 = "pictureinactive";
      this.pictureStatus3 = "pictureactive";
    }
 }

}
